import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { FxFlexDirective, FxLayoutAlignDirective, FxLayoutDirective, FxLayoutGapDirective } from '@rspl-ui';

@Component({
  selector: 'app-categorize-help-dialog',
  templateUrl: './courier-remove-stairs-dialog.component.html',
  styleUrls: ['./courier-remove-stairs-dialog.component.scss'],
  imports: [
    FxLayoutDirective,
    FxLayoutGapDirective,
    FxFlexDirective,
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatRadioGroup,
    FormsModule,
    MatRadioButton,
    MatDialogActions,
    FxLayoutAlignDirective,
  ],
})
export class CourierRemoveStairsDialogComponent {
  removeStairs = false;

  constructor(public reference: MatDialogRef<CourierRemoveStairsDialogComponent>) {}
}
